import { useCallback, useContext } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import config from '@/config';
import { AppContext } from '@/app.context';

import { clearCache, eraseAllData } from './clear-app-data';

/**
 * The two levels of Settings → Offline & storage → Cache, bound to this
 * app's query client and KV store. Each reloads the app; neither asks for
 * confirmation (the caller does).
 */
export function useClearAppData(): {
	clearCache: () => Promise<void>;
	eraseAllData: () => Promise<void>;
} {
	const queryClient = useQueryClient();
	const { kv } = useContext(AppContext);

	return {
		clearCache: useCallback(() => clearCache({ queryClient, kv }), [queryClient, kv]),
		eraseAllData: useCallback(() => eraseAllData(config.build.appKey), []),
	};
}
